import { useMutation } from 'react-query';
import { createAdjustmentComment } from 'apis/adjustmentComments.api';

const useCreateAdjustmentComment = () => {
  const { mutateAsync, ...rest } = useMutation(createAdjustmentComment);

  return {
    mutateAsync,
    ...rest,
  };
};

export default useCreateAdjustmentComment;
